var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#7e22ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#e5d3f5",
    transform: "rotate(30 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#e5d3f5",
    transform: "rotate(60 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#e5d3f5",
    transform: "rotate(90 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#e5d3f5",
    transform: "rotate(120 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#d8bcf0",
    transform: "rotate(150 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#cba7eb",
    transform: "rotate(180 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#be90e6",
    transform: "rotate(210 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#b27ae2",
    transform: "rotate(240 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#a464dd",
    transform: "rotate(270 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#984ed8",
    transform: "rotate(300 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#8b38d3",
    transform: "rotate(330 64 64)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64",
    calcMode: "discrete",
    dur: "1080ms",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.e620216887be72087da7ea8976853168.svg";
export { ForwardRef as ReactComponent };